/* eslint-disable no-dupe-keys */
export default {
  magcard_swipe_record: {
    name: '刷卡启动记录',
    // 属性（一般与对象内容匹配）
    prop: {
      magcard_number: '磁卡编号',
      magcard: '磁卡',
      user: '用户',
      charge_station: '充电站',
      charger: '充电桩',
      verify_result: '刷卡结果',
      description: '描述',
      service_provider: '运营商',
      created_at: '刷卡时间'
    },
    // Enum的属性
    verify_results: {
      success: '成功',
      balance_not_enough: '余额不足',
      charger_forbidden: '无权在此桩充电',
      password_error: '密码错误',
      card_not_exist: '非法卡',
      charger_start_failed: '桩启动失败',
      non_operating_hours: '不对外开放'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询磁卡编号/站名/桩编号'
    }
    // 详情页标签
  }
}
